import { useMemo } from "react";
import { useAuth } from "../../context";
import { formatDateByLocale } from "../dateHelpers";

export function useFormatDateByLocale(date: Date): string {
    const { user } = useAuth();
  
    return useMemo(
      () => formatDateByLocale(date, user.localePreference),
      [date, user.localePreference]
    );
  }